var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 140 200 120",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.391 156.748 L 148.267 171.627 125.143 194.753 L 102.019 217.879 118.713 218.109 C 127.895 218.236,144.998 218.339,156.718 218.339 L 178.029 218.339 216.263 180.104 L 254.497 141.869 186.506 141.869 L 118.515 141.869 133.391 156.748 M182.234 218.285 L 144.227 256.293 147.633 256.518 C 151.991 256.807,179.381 256.806,235.235 256.517 L 279.640 256.287 265.080 241.723 C 257.071 233.713,250.519 227.005,250.519 226.816 C 250.519 226.627,260.912 216.078,273.615 203.375 L 296.711 180.277 258.476 180.277 L 220.241 180.277 182.234 218.285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de51aeb3df03b8a9699bf356b1c2ca1f.svg";
export { ForwardRef as ReactComponent };